define('home/views/PostView',[  // eslint-disable-line requirejs/amd-function-arity
    'backbone-marionette',
    'core/strings',

    'home/mixins/withSubviews',

    'home/views/PostActionsView',
    'home/views/PostContentView',
    'home/views/CollapsingPostContentView',
    'home/utils/datetimeUtils',

    'home/templates/post',

    // imported for side effects
    // TODO: find a better place to put this. required here in order to use imported UpvotersCard
    'home/utils/cardUtils',
], function (
    Marionette,
    strings,

    withSubviews,

    PostActionsView,
    PostContentView,
    CollapsingPostContentView,
    datetimeUtils,

    postTemplate
) {
    'use strict';

    var gettext = strings.get;

    var parent = Marionette.ItemView;


    /**
     * A view of a post, including the author's details above, the post content including
     * rich media, and standard post actions below.
     */
    var PostView = parent.extend({
        className: 'card-comment',
        template: postTemplate,
        templateHelpers: function () {
            var state = this.model.get('state');

            return {
                isHidden: state !== 'visible',
                hiddenExplanation: {
                    flagged: gettext('Pending'),
                    pending: gettext('Pending'),
                    spam: gettext('Detected as spam'),
                    deleted: gettext('Removed'),
                }[state],
                discussionRoute: this.model.thread.getDiscussionRoute(),
                relativeTime: datetimeUtils.getRelativeDatetime(this.model.get('createdAt')),
            };
        },

        initialize: function (options) {
            options = options || {};

            this.hideActions = options.hideActions;
            this.shouldCollapse = options.shouldCollapse;
        },

        regions: {
            postContentRegion: '[data-role=post-content]',
            postActionsRegion: '[data-role=post-actions]',
        },

        onRender: function () {
            this.activateRegion(this.postContentRegion, this.createPostContentView);

            if (!this.hideActions)
                this.activateRegion(this.postActionsRegion, this.createPostActionsView);
        },

        createPostActionsView: function () {
            return new PostActionsView({
                el: this.postActionsRegion.el,
                model: this.model,
                parentPostView: this,
            });
        },

        createPostContentView: function () {
            var PostContentViewClass = this.shouldCollapse ?
                CollapsingPostContentView :
                PostContentView;

            return new PostContentViewClass({
                el: this.postContentRegion.el,
                model: this.model,
            });
        },
    });


    var proto = PostView.prototype;
    withSubviews.call(proto);

    return PostView;
});

